<div class="row" *ngIf='readOnly'>
  <div class="col-md-12 col-sm-12 table-responsive no-border">
    <form [formGroup]="deviceForm" novalidate>

      <table class="table table-inner table-condensed table-striped" *ngIf="!sppDevice && applicableRegulation != 'IVDR' && !isSwissdamedIvddDeviceRegulation()">
        <tbody>
          <tr>
            <th role="columnheader" aria-label="Containing Latex?">
              Containing Latex?
            </th>
          </tr>
          <tr>
            <td role="gridcell" aria-label="Cell of Containing Latex" [ngClass]="isDefault('Containing Latex?')">
              <label controlName="containingLatex"> </label>
            </td>
          </tr>
        </tbody>
      </table>
      <table formArrayName="CMRForm" class="table table-inner table-condensed table-striped" *ngIf="!sppDevice && applicableRegulation != 'IVDR' && !isSwissdamedLegacyDeviceRegulation() && !isSwissdamedIvddDeviceRegulation()">
        <tbody>
          <tr>
            <th role="columnheader" aria-label="CMR or Endocrine Disrupting Substance Type" class="col-sm-3">
              CMR or Endocrine Disrupting Substance Type
            </th>
            <th role="columnheader" aria-label="CAS Number" class="col-sm-2">
              CAS Number
            </th>
            <th role="columnheader" aria-label="EC Number" class="col-sm-2">
              EC Number
            </th>
            <th role="columnheader" aria-label="Substance Name" class="col-sm-2">
              Substance Name
            </th>
            <th role="columnheader" aria-label="Language" class="col-sm-2">
              Language
            </th>
          </tr>
          <ng-container *ngIf="CMRForm?.controls?.length; else emptyTemplate5fields">
          <tr formGroupName="{{i}}"
            *ngFor="let substance of CMRForm.controls; let i = index" [ngClass]="isDefault('CMR')">
            <td role="gridcell" aria-label="Cell of CMR or Endocrine Disrupting Substance Type">
              <label controlName="CMRValue"></label>
            </td>
            <td role="gridcell" aria-label="Cell of CAS Number">
              <label controlName="casNumber"></label>
            </td>
            <td role="gridcell" aria-label="Cell of EC Number">
              <label controlName="ecNumber"></label>
            </td>
            <td>
              <table formArrayName="substanceNamesArray" class="table table-inner table-condensed">
                <tr formGroupName="{{i}}"
                  *ngFor="let comment of substance.get('substanceNamesArray').controls; let i = index">
                  <td role="gridcell" aria-label="Substance Name" class="no-top-padding-inner-table"
                    [ngClass]="isDefault('CMR')">
                    <label controlName="value"></label>
                  </td>
                </tr>
              </table>
            </td>
            <td>
              <table formArrayName="substanceNamesArray" class="table table-inner table-condensed">
                <ng-container *ngIf="substance.get('substanceNamesArray')?.controls?.length; else emptyTemplate1fields">
                <tr formGroupName="{{i}}"
                  *ngFor="let comment of substance.get('substanceNamesArray').controls; let i = index">
                  <td role="gridcell" aria-label="Cell of Language" class="no-top-padding-inner-table"
                    [ngClass]="isDefault('CMR')">
                    <label controlName="language"></label>
                  </td>
                </tr>
              </ng-container>
              </table>
            </td>
          </tr>
        </ng-container>
        </tbody>
      </table>
      <table formArrayName="substancesForm" class="table table-inner table-condensed table-striped" *ngIf="!sppDevice && applicableRegulation != 'IVDR' && !isSwissdamedIvddDeviceRegulation()">
        <tbody>
          <tr>
            <th role="columnheader" aria-label="Medicinal or Medicinal Human Product Substance Type" class="col-sm-5">
              Medicinal or Medicinal Human Product Substance Type
            </th>
            <th role="columnheader" aria-label="INN Code" class="col-sm-2">
              INN Code
            </th>
            <th role="columnheader" aria-label="Substance Name" class="col-sm-2">
              Substance Name
            </th>
            <th role="columnheader" aria-label="Language" class="col-sm-2">
              Language
            </th>
          </tr>
          <ng-container *ngIf="substancesForm?.controls?.length; else emptyTemplate4fields">
          <tr formGroupName="{{i}}" *ngFor="let substance of substancesForm.controls; let i = index"
            [ngClass]="isDefault('MED Human Product Types')">
            <td role="gridcell" aria-label="Cell of Medicinal or Medicinal Human Product Substance Type">
              <label controlName="substanceType"></label>
            </td>
            <td role="gridcell" aria-label="Cell of INN Code">
              <label controlName="innCode"></label>
            </td>
            <td>
              <table formArrayName="substanceNamesArray" class="table table-inner table-inline">
                <ng-container *ngIf="substance.get('substanceNamesArray')?.controls?.length; else emptyTemplate1fields">
                <tr formGroupName="{{i}}"
                  *ngFor="let comment of substance.get('substanceNamesArray').controls; let i = index">
                  <td role="gridcell" aria-label="Cell of Substance Name" [ngClass]="isDefault('MED Human Product Types')">
                    <label controlName="value"></label>
                  </td>
                </tr>
              </ng-container>
              </table>
            </td>
            <td>
              <table formArrayName="substanceNamesArray" class="table table-inner table-inline">
                <ng-container *ngIf="substance.get('substanceNamesArray')?.controls?.length; else emptyTemplate1fields">
                <tr formGroupName="{{i}}"
                  *ngFor="let comment of substance.get('substanceNamesArray').controls; let i = index">
                  <td role="gridcell" aria-label="Cell of Language" [ngClass]="isDefault('MED Human Product Types')">
                    <label controlName="language"></label>
                  </td>
                </tr>
              </ng-container>
              </table>
            </td>
          </tr>
        </ng-container>
        </tbody>
      </table>
      <table formArrayName="criticalWarningForm" class="table table-inner table-condensed table-striped">
        <tbody>
          <tr>
            <th role="columnheader" aria-label="Critical Warning or Contraindication Value(s)" class="col-sm-6">
              Critical Warning or Contraindication Value(s)
            </th>
            <th role="columnheader" aria-label="Comment" class="col-sm-4">
              Comment
            </th>
            <th role="columnheader" aria-label="Language" class="col-sm-2">
              Language
            </th>
          </tr>
          <ng-container *ngIf="criticalWarningForm?.controls?.length; else emptyTemplate3fields">
          <tr formGroupName="{{i}}" *ngFor="let warning of criticalWarningForm.controls; let i = index"
            [ngClass]="isDefault('Critical Warning or Contraindication Value(s)')">
            <td role="gridcell" aria-label="Cell of Critical Warning or Contraindication Value(s)">
              <label controlName="warningValue"></label>
            </td>
            <td>
              <table formArrayName="warningCommentsArray" class="table table-inner table-inline">
                <ng-container *ngIf="warning.get('warningCommentsArray')?.controls?.length; else emptyTemplate1fields">
                <tr formGroupName="{{i}}"
                  *ngFor="let comment of warning.get('warningCommentsArray').controls; let i = index">
                  <td role="gridcell" aria-label="Cell of Comment" class="no-top-padding-inner-table"
                    [ngClass]="isDefault('Critical Warning or Contraindication Value(s)')">
                    <label controlName="value"></label>
                  </td>
                </tr>
              </ng-container>
              </table>
            </td>
            <td>
              <table formArrayName="warningCommentsArray" class="table table-inner table-inline">
                <ng-container *ngIf="warning.get('warningCommentsArray')?.controls?.length; else emptyTemplate1fields">
                <tr formGroupName="{{i}}"
                  *ngFor="let comment of warning.get('warningCommentsArray').controls; let i = index">
                  <td role="gridcell" aria-label="Cell of Language" class="no-top-padding-inner-table"
                    [ngClass]="isDefault('Critical Warning or Contraindication Value(s)')">
                    <label controlName="language"></label>
                  </td>
                </tr>
              </ng-container>
              </table>
            </td>
          </tr>
        </ng-container>
        </tbody>
      </table>
    </form>
  </div>
</div>
<ng-template #emptyTemplate1fields>
  <tr>
    <td role="gridcell"><label></label></td>
  </tr>
</ng-template>
<ng-template #emptyTemplate3fields>
  <tr>
    <td role="gridcell"><label></label></td>
    <td role="gridcell"><label></label></td>
    <td role="gridcell"><label></label></td>
  </tr>
</ng-template>
<ng-template #emptyTemplate4fields>
  <tr>
    <td role="gridcell"><label></label></td>
    <td role="gridcell"><label></label></td>
    <td role="gridcell"><label></label></td>
    <td role="gridcell"><label></label></td>
  </tr>
</ng-template>
<ng-template #emptyTemplate5fields>
  <tr>
    <td role="gridcell"><label></label></td>
    <td role="gridcell"><label></label></td>
    <td role="gridcell"><label></label></td>
    <td role="gridcell"><label></label></td>
    <td role="gridcell"><label></label></td>
  </tr>
</ng-template>


